import Vue from 'vue'
import router from './router'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import './registerServiceWorker'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'drawing'
  }
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
